// extracted by css-extract-rspack-plugin
export default {"hideOnDesktop":"ConversationActions-module__hideOnDesktop__pQdcN"};